import { Schema } from "effect";
export const CancelDetails = Schema.Struct({
    interviewer: Schema.NonEmptyString,
    startTimeDate: Schema.Date,
});
